@use "~theme/typographyV2" as typography;
@use "~theme/breakpoints";

.container {
  width: auto;
}

.container p {
  @include typography.body;
  text-align: center;
  margin-bottom: 1em;
}

.container strong {
  font-weight: var(--semibold-weight);
}

.header {
  @include typography.heading3;
  text-align: center;
  margin: 0;
}

.ctas {
  display: flex;
  margin-top: 32px;
  flex-wrap: wrap;

  @include breakpoints.desktop {
    flex-wrap: nowrap;
  }
}

.button {
  flex: 1;
  margin: 0 8px;
  width: 230px !important;
  height: 40px !important;
  font-family: typography.$font-mont !important;
  font-weight: 600 !important;
  font-size: 14px !important;
  background-color: var(--blue-01) !important;
  color: var(--white) !important;
  border-radius: 100px !important;
  display: flex !important;
  align-items: center !important;
  justify-content: center !important;
  text-transform: none !important;

  &:first-child {
    margin-left: 0;
  }

  &:last-child {
    margin-right: 0;
  }
}
